import React, { useState, useEffect, useCallback } from 'react';
import axiosClient from '../../axios-client';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons'
import MyPagination from "../../components/MyPagination";
import { useStateContext } from "../../context/ContextProvider";
import { BiLeftArrowAlt } from 'react-icons/bi';
import MySelect from 'react-select';

import makeAnimated from 'react-select/animated';
import Resizer from "react-image-file-resizer";

import {
    IconButton,
    Flex,
    Box,
    Button,
    Stack,
    Table,
    Thead,
    InputGroup,
    InputLeftElement,
    Tbody,
    Tr,
    Th,
    Avatar,
    Td,
    Input,
    FormControl,
    FormLabel,
    useToast,
    TableContainer,
    useColorModeValue,
    useDisclosure,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Select,
    Alert,
    AlertIcon,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    Text,
    Tag,
    PopoverFooter,
    TagCloseButton,
    Textarea,
    TagLabel,
    Skeleton,
    Switch,
    Badge

} from '@chakra-ui/react';
import { PiPlus, PiPlusBold } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { FaHistory } from 'react-icons/fa';

export const GestCategory = () => {
    const animatedComponents = makeAnimated();
    const { t } = useTranslation();
    const [loadingData, setLoadingData] = useState(true)
    const [checkLengthData, setCheckLengthData] = useState(false)

    const [isAddFormOpen, setIsAddFormOpen] = useState(false);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [paginationData, setPaginationData] = useState()
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedEtat, setSelectedEtat] = useState(null);

    const toast = useToast()
    const { isOpen, onOpen, onClose } = useDisclosure();

    //search variable
    const [searchTerm, setSearchTerm] = useState('');

    const navigate = useNavigate()

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isCatOpen, setIsCatOpen] = useState(false);
    //Modal
    const [changeModal, setChangeModal] = useState(true)
    const [showControls, setShowControls] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };


    const onOpenCat = () => {
        setIsCatOpen(true);
    };

    const onCloseCat = () => {
        setIsCatOpen(false);
        setMessage('')
    };



    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////

    // current user
    const { user, setUser } = useStateContext();


    const [catId, setCatId] = useState(null);
    const cancelRef = React.useRef()

    //Category data
    const [data, setData] = useState([]);
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [sCatDescription, setSCatDescription] = useState();

    const [message, setMessage] = useState('');
    const [scatName, setScatName] = useState('');

    const [scatNameEdit, setScatNameEdit] = useState('');
    const [sCatDescriptionEdit, setSCatDescriptionEdit] = useState();

    const [sCatData, setSCatData] = useState([]);
    const [catData, setCatData] = useState([]);


    const [loading, setLoading] = useState(true)


    //get the data
    useEffect(() => {
        // setLoadingData(true)

        axiosClient.get(`/categories/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);
                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });

        axiosClient.get('subcategories/')
            .then((res) => {
                const sortedData = res.data.sort((a, b) => a.order - b.order);
                setSCatData(sortedData);

            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });


    }, [pageSize, currentPage, searchTerm, showControls, selectedEtat])

    const AjoutCategory = () => {
        setIsLoading(true)
        if (!name || name.trim() === "") {
            setMessage(t("Veuillez remplir le nom"))
            return;
        }

        const formData = new FormData()
        formData.append("name", name)
        formData.append("description", description)
        formData.append("etat", true)
        formData.append('edited_by', `${user.last_name} ${user.first_name}`);

        if (data.length > 0) {
            const check = data.find(obj => {
                return obj.name.toLowerCase() === name.toLowerCase().trim();
            })
            if (check) {
                setIsLoading(false)
                setMessage(t('Cette catégorie existe déja !'))
                return

            }
        }
        axiosClient.post('/categories/create/', formData)
            .then((response) => {
                setData([response.data, ...data]);
                setName('')
                setDescription('')
                setMessage("")

                toast({
                    description: `${t("La catégorie")} ${name} ${t("est ajoutée avec succès")} `,
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
                onClose()
                setIsLoading(false)

            }).catch((err) => {
                setIsLoading(false)
                const response = err.response;

            })

    }
    function update() {
        axiosClient.get(`/categories/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);
                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });

        axiosClient.get('subcategories/')
            .then((res) => {
                setSCatData(res.data.sort().reverse())

            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)
            });

    }
    function reset() {

        setIsAddFormOpen(false)
        setIsEditFormOpen(false)
        setMessage('')
        setScatNameEdit('')
    }

    const AjoutSubCategory = () => {
        setIsLoading(true)
        if (!scatName || scatName.trim() === "") {
            setMessage(t("Veuillez remplir le nom"))
            return;
        }
        const formData = new FormData()
        formData.append("name", scatName)
        formData.append("category", catId)
        formData.append("description", sCatDescription)


        if (sCatData.length > 0) {
            const check = sCatData.find(obj => {
                return obj.name.toLowerCase() === scatName.toLowerCase().trim()
            })
            if (check) {
                setIsLoading(false)
                setMessage(t('Cette sous catégorie existe déja !'))
                return
            }
        }
        axiosClient.post('/subcategories/create/', formData)
            .then((response) => {
                setMessage("")
                toast({
                    description: `${t("La sous catégorie")} ${scatName}  ${t("est ajoutée avec succès")}`,
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
                setScatName('')

                update()
                reset()
                setIsLoading(false)
            }).catch((err) => {
                setIsLoading(false)
                const response = err.response;

            })
    }



    const updateCategory = (id) => {
        setIsLoading(true)
        if (!catData.name || catData.name.trim() === "") {
            setMessage(t("Veuillez remplir le nom"))
            return;
        }

        const formData = new FormData();
        if (name) formData.append("name", name);
        if (description) formData.append("description", description);
        formData.append('edited_by', `${user.last_name} ${user.first_name}`);
        const newList = data.filter((e) => e.id !== id)
        if (name) {
            if (newList.length > 0) {
                const check = newList.find(obj => {
                    return obj.name.toLowerCase() === name.toLowerCase()
                })
                if (check) {
                    setIsLoading(false)
                    setMessage(t('Cette catégorie existe déja !'))
                    return
                }
            }
        }
        axiosClient.put(`/categories/update/${id}/`, formData).then((res) => {
            toast({
                description: `${t("La catégorie")} ${t("est modifiée avec succès")}`,
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
            setName('')
            setDescription('')
            setMessage("")
            update()
            onClose()
            setIsLoading(false)
        }).catch((err) => {
            setIsLoading(false)
            const response = err.response;

        })

    }
    const updateSousCategory = (id) => {
        setIsLoading(true)
        if (!sousCat.name || sousCat.name.trim() === "") {
            setMessage(t("Veuillez remplir le nom"))
            setScatName('')
            return;
        }
        const formData = new FormData();
        if (scatNameEdit) formData.append("name", scatNameEdit);
        if (sCatDescriptionEdit) formData.append("description", sCatDescriptionEdit)

        const newList = sCatData.filter((e) => e.id !== id)
        if (scatNameEdit) {
            if (newList.length > 0) {
                const check = newList.find(obj => {

                    return obj.name.toLowerCase() === scatNameEdit.toLowerCase()
                })
                if (check) {
                    setIsLoading(false)
                    setMessage(t('Cette sous catégorie existe déja !'))
                    return
                }


            }
        }

        axiosClient.put(`/subcategories/update/${id}/`, formData).then(() => {

            toast({
                // title: 'Modification',
                description: t(`La sous catégorie est modifiée avec succès`),
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
            reset()
            update()
            setScatNameEdit('')
            setIsLoading(false)
        }).catch((err) => {
            setIsLoading(false)
            const response = err.response;

        })


    }
    const handleDelete = (id = catId) => {
        if (!id) return;
        axiosClient.delete(`/categories/delete/${id}/`)
            .then((response) => {
                setData((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("La catégorie est supprimée avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const handleSCatDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/subcategories/delete/${id}/`)
            .then((response) => {
                setSCatData((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("La sous catégorie est supprimée avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right',
                    variant: 'left-accent',
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        // update()
        // onCloseAlert()
    }



    const initRef = React.useRef()

    const [sousCat, setSousCat] = useState([])

    const selectSousCat = (id) => {
        axiosClient.get(`/subcategories/${id}/`).then(res => {
            setSousCat(res.data)
        })
    }


    const handleEtatClick = (id, etat) => {
        const formData = new FormData();
        formData.append("etat", !etat);
        formData.append('edited_by', `${user.last_name} ${user.first_name}`);
        axiosClient.put(`/categories/update/${id}/`, formData)
            .then((response) => {
                const updatedRow = response.data;
                // Update the row object with the new etat value
                setData(rows => rows.map(row => {
                    if (row.id === id) {
                        return {
                            ...row,
                            etat: !etat,
                            // date_modification: updatedRow.date_modification.format('YYYY-MM-DD HH:mm:ss'),
                            // edited_by: updatedRow.edited_by || (user.first_name + ' ' + user.last_name),
                        };
                    }
                    return row;
                }));
            })
            .catch((error) => {
                // console.error(error)
            }

            );
        if (!etat) {
            toast({
                description: t("la catégorie est activé"),
                variant: 'left-accent',
                status: 'success',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
        else {
            toast({
                description: t("la catégorie est désactivé"),
                status: 'success',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
    }

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        // Reorder the items
        const reorderedItems = Array.from(data);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setData(reorderedItems);

        // Update the database with the new order
        updateDatabase(reorderedItems);
    };

    // Fonction pour simuler la mise à jour dans la base de données
    const updateDatabase = (newOrder) => {
        const updatedOrder = newOrder.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        axiosClient.post('/categories/update_order/', updatedOrder)
            .then(response => {
                // console.log("Order updated successfully:", response.data);
            })
            .catch(error => {
                // console.error("Error updating order:", error);
            });
    };
    const handleOnDragEndScat = (result) => {
        if (!result.destination) return;

        // Filter subcategories for the current category
        const filteredItems = sCatData.filter(row => row.category === catId);

        // Reorder the subcategories for the current category
        const reorderedItems = Array.from(filteredItems);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        setSCatData(reorderedItems); // Update state

        // Update the database with new order
        updateDatabaseScat(reorderedItems);
    };




    // Fonction pour simuler la mise à jour dans la base de données
    const updateDatabaseScat = (newOrder) => {
        // Group subcategories by category_id and reset their order
        const groupedOrder = newOrder.map((item, index) => ({
            id: item.id,
            order: index, // Update order based on new position
            category: item.category, // Retain category information for the update
        }));

        // Send the updated order to the backend
        axiosClient.post('/subCategories/update_order/', groupedOrder)
            .then(response => {
                console.log("Order updated successfully:", response.data);
            })
            .catch(error => {
                console.error("Error updating order:", error);
            });
    };


    return (
        <Box mt="5px" >
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span>{t('Catégories')}</span></Text>
                    <Button onClick={() => {
                        setChangeModal(true)
                        onOpen()
                    }}
                        leftIcon={<PiPlusBold />} color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} variant='solid'>
                        {t("Ajouter catégorie")}
                    </Button>
                </Box>

            </Flex>


            <Flex
                align={'center'}
                justify={'center'}
            >
                <Stack
                    w={'full'}
                    maxW='full'
                    bg={useColorModeValue('white', 'gray.700')}
                    rounded={'lg'}
                    p={6}
                    my={5}>
                    {/* Search input */}
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        direction={{ base: 'column', lg: 'row' }}
                    >

                        <Select borderRadius="5" size="sm" fontSize={{ base: 13, lg: 16 }} w={{ base: '30%', lg: "20%" }} mb={4} value={selectedEtat} onChange={(e) => setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')}>
                            <option value="">{t("Tout")}</option>
                            <option value="true">{t("Activé")}</option>
                            <option value="false">{t("Désactivé")}</option>
                        </Select>
                        <InputGroup size={"sm"} w={{ base: '100%', lg: "30%" }}>
                            <InputLeftElement
                                pointerEvents='none'
                                children={<SearchIcon color='gray.300' />}
                            />
                            <Input
                                borderRadius={"5"}
                                placeholder={t("Recherche...")}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                mb={4}
                                sx={{
                                    marginLeft: 'auto',
                                }}
                            />  </InputGroup>

                    </Flex>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <TableContainer ref={provided.innerRef} {...provided.droppableProps} >
                                    <Table size={"sm"} >
                                        <Thead>
                                            <Tr>
                                                <Th fontFamily='Plus Jakarta Display'>{t('Nom')}</Th>
                                                <Th fontFamily='Plus Jakarta Display'>Description</Th>
                                                <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("État")}</Th>
                                                {/* <Th fontFamily='Plus Jakarta Display'>Ajoutée par</Th> */}
                                                <Th fontFamily='Plus Jakarta Display'>{t("Date Création")}</Th>
                                                <Th fontFamily='Plus Jakarta Display'>{t("Sous Catégorie")}</Th>
                                                {/* <Th fontFamily='Plus Jakarta Display'>Historique</Th> */}

                                                <Th fontFamily='Plus Jakarta Display'>Options</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {loadingData &&
                                                <Tr>
                                                    <Td> <Skeleton height='20px' /></Td>
                                                    <Td> <Skeleton height='20px' /></Td>
                                                    <Td> <Skeleton height='20px' /></Td>
                                                    <Td> <Skeleton height='20px' /></Td>
                                                    <Td> <Skeleton height='20px' /></Td>
                                                    <Td> <Skeleton height='20px' /></Td>

                                                </Tr>}
                                            {(paginationData?.length !== 0) ?
                                                data.map((row, index) => (
                                                    <Draggable key={row.id} draggableId={row.id.toString()} index={index}>
                                                        {(provided) => (

                                                            <Tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} p={0} key={row.id}>
                                                                <Td>{row.name}</Td>
                                                                <Td >
                                                                    <Flex flexDirection='row' gap={1}>
                                                                        {row.description.length > 0 ?
                                                                            <>
                                                                                <Text>{row.description.substring(0, 20)} {row.description.length > 20 && <>...</>}</Text>
                                                                                <Popover>
                                                                                    <PopoverTrigger >
                                                                                        <Text cursor='pointer' _hover={{ color: 'lightgray' }}> {row.description.length > 20 && <>{t("(voir plus)")}</>} </Text>
                                                                                    </PopoverTrigger>
                                                                                    <PopoverContent >
                                                                                        <PopoverArrow />
                                                                                        {/* <PopoverCloseButton /> */}
                                                                                        <PopoverBody>
                                                                                            <Textarea readOnly border={"none"} resize='none' value={row.description}>
                                                                                                {row.description}
                                                                                            </Textarea>
                                                                                        </PopoverBody>
                                                                                    </PopoverContent>
                                                                                </Popover>
                                                                            </>

                                                                            :
                                                                            <Text color={'gray.400'}>{t("Non disponible")}</Text>



                                                                        }

                                                                    </Flex>

                                                                </Td>
                                                                <Td>
                                                                    <Flex>
                                                                        <Stack direction='row' mr="3px">
                                                                            {(user.role === "SUPERADMIN" || user.role === "ADMIN") &&
                                                                                <Switch
                                                                                    colorScheme='green'
                                                                                    isChecked={row.etat}
                                                                                    onChange={() => handleEtatClick(row.id, row.etat)}
                                                                                />
                                                                            }
                                                                        </Stack>

                                                                        <Badge
                                                                            size="sm"
                                                                            rounded={'lg'}
                                                                            colorScheme={!row.etat ? 'red' : 'green'}
                                                                        >
                                                                            {row.etat ? t("Activé") : t("Désactivé")}

                                                                        </Badge>
                                                                    </Flex>
                                                                </Td>
                                                                {/* <Td>{row.added_by}</Td> */}
                                                                <Td>{new Date(row.creation_date).toLocaleDateString('fr-FR')}</Td>
                                                                <Td><Button
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        onOpenCat()
                                                                        // setChangeModal(false)
                                                                        // setName(row.name)
                                                                        setCatId(row.id);
                                                                        // onOpen();
                                                                    }}
                                                                    color={"white"} bgGradient='linear(to-r, #29a4a6,#6ad7d9)' _hover={{ bgGradient: 'linear(to-r, #29a4a6,#29a4a6)' }}
                                                                >
                                                                    {t("Sous catégorie")}
                                                                </Button></Td>


                                                                <Td>
                                                                    <Button
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setChangeModal(false)
                                                                            setCatData(row)
                                                                            setCatId(row.id);
                                                                            onOpen();

                                                                        }}

                                                                        variant={'outline'}
                                                                        colorScheme='yellow'

                                                                        leftIcon={<EditIcon />}>
                                                                        {t("Modifier")}
                                                                    </Button>
                                                                    <Button
                                                                        ml={5}
                                                                        variant={'outline'}
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            navigate(`/historique_categorie`, {
                                                                                state: {
                                                                                    categoryId: row?.id,
                                                                                },
                                                                            })
                                                                        }}
                                                                        colorScheme='teal'
                                                                        leftIcon={<FaHistory />}>
                                                                        {t("Historique")}
                                                                    </Button>
                                                                    {(user.role === "SUPERADMIN") && <Button
                                                                        ml={5}
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            setCatId(row.id);
                                                                            onOpenAlert();
                                                                        }}
                                                                        colorScheme='red'
                                                                        leftIcon={<DeleteIcon />}>
                                                                        {t("Supprimer")}
                                                                    </Button>
                                                                    }
                                                                    
                                                                </Td>
                                                            </Tr>
                                                        )}
                                                    </Draggable>
                                                ))
                                                :
                                                !searchTerm &&
                                                (<Tr>
                                                    <Td colSpan={8}>{t("il n'y a pas encore de données.")}</Td>
                                                </Tr>)

                                            }

                                            {(((searchTerm || selectedEtat !== null) && paginationData?.length === 0) || (checkLengthData)) && (
                                                <Tr>
                                                    <Td colSpan={8}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                                                </Tr>

                                            )}
                                        </Tbody>
                                    </Table>

                                </TableContainer>
                            )}
                        </Droppable>
                    </DragDropContext>
                    {/* Pagination */}
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                        </Box>

                        <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            {/* Add more options as needed */}
                        </Select>
                    </Flex>
                </Stack>
            </Flex>

            <AlertDialog
                size={'lg'}
                isOpen={isCatOpen}
                leastDestructiveRef={cancelRef}
                onClose={() => {
                    onCloseCat()
                    reset()
                }}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>

                            {(isAddFormOpen && !isEditFormOpen) ?
                                <Flex align={'center'} justifyContent={"space-between"} >
                                    <Text>{t("Ajouter une sous catégorie")}</Text>
                                    <IconButton _hover={'none'} background={'none'} icon={<BiLeftArrowAlt size={25} />} onClick={() => {
                                        setIsAddFormOpen(false)
                                        setMessage('')

                                    }}></IconButton>
                                </Flex>
                                : (isEditFormOpen && !isAddFormOpen) ?
                                    <Flex align={'center'} justifyContent={"space-between"} >
                                        <Text>{t("Modifier la sous catégorie")}</Text>
                                        <IconButton _hover={'none'} background={'none'} icon={<BiLeftArrowAlt size={25} />} onClick={() => {
                                            setIsEditFormOpen(false)
                                            setMessage('')
                                            setScatNameEdit('')
                                        }}></IconButton>
                                    </Flex>
                                    : t('Liste des sous catégories')}

                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }

                            {isEditFormOpen &&
                                //Edit form
                                <>
                                    <Flex w="100%" flexDirection={'column'}>
                                        <FormControl mb={2} isRequired>
                                            <FormLabel>{t("Nom du sous catégorie")}</FormLabel>
                                            <Input defaultValue={sousCat.name} maxLength={50} name="name" onChange={e => setScatNameEdit(e.target.value)} placeholder={t("Nom du sous catégorie")} />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Description</FormLabel>
                                            <Textarea defaultValue={sousCat.description} height={"100px"} resize={"none"} type='text' maxLength={250} name="description" onChange={e => setSCatDescriptionEdit(e.target.value)} placeholder={t("Description du sous catégorie...")} />
                                        </FormControl>
                                    </Flex>

                                </>}
                            {isAddFormOpen &&
                                //Add form
                                <>
                                    <Flex w="100%" flexDirection={'column'}>
                                        <FormControl mb={2} isRequired>
                                            <FormLabel>{t("Nom du sous catégorie")}</FormLabel>
                                            <Input maxLength={50} name="name" onChange={e => setScatName(e.target.value)} placeholder={t("Nom du sous catégorie")} />
                                        </FormControl>
                                        <FormControl isRequired>
                                            <FormLabel>Description</FormLabel>
                                            <Textarea height={"100px"} resize={"none"} type='text' maxLength={250} name="description" onChange={e => setSCatDescription(e.target.value)} placeholder={t("Description du sous catégorie...")} />
                                        </FormControl>
                                    </Flex>

                                </>
                            }

                            {(!isAddFormOpen && !isEditFormOpen) ?
                                //list des sous catégories
                                <Flex flexDirection={'column'}>
                                    <Flex justify={"end"}>
                                        <Button leftIcon={<PiPlus />} w={'fit-content'} colorScheme='green' onClick={() => {
                                            setIsAddFormOpen(true)
                                        }} >{t("Sous catégorie")}</Button>
                                    </Flex>
                                    <Box
                                        // ref={provided.innerRef}
                                        // {...provided.droppableProps}
                                        height={100}
                                        mt={5}
                                        style={{
                                            border: '1px solid lightgray',
                                            padding: "15px 10px",
                                            borderRadius: '10px',
                                            overflow: 'auto',
                                        }}
                                    >
                                        {sCatData.length !== 0 &&
                                            sCatData
                                                .filter((row) => row.category === catId)
                                                .map((val, key) => (
                                                    <Tag
                                                        key={key}
                                                        onMouseEnter={() => setShowControls(val.id)}
                                                        onMouseLeave={() => setShowControls(null)}
                                                        borderRadius='full'
                                                        colorScheme='gray'
                                                        m={1}
                                                    >

                                                        <TagLabel

                                                        >
                                                            {val.name}
                                                        </TagLabel>
                                                        <Flex

                                                            display={showControls === val.id ? 'flex' : 'none'}
                                                            align={"center"}>

                                                            <EditIcon
                                                                onClick={() => {
                                                                    selectSousCat(val.id);
                                                                    setSousCat('');
                                                                    setIsEditFormOpen(true);
                                                                }}
                                                                ml={5}
                                                                cursor={"pointer"}
                                                                aria-label="Delete filter section"
                                                                // icon={<CloseIcon />}
                                                                color="green"
                                                                variant="outline"
                                                            // onClick={() => removeFeature(index)}
                                                            />
                                                             {(user.role === "SUPERADMIN") &&
                                                            <Popover size={'sm'} placement="bottom" initialFocusRef={initRef}>
                                                                {({ isOpen, onClose }) => (
                                                                    <>
                                                                        <PopoverTrigger>
                                                                            <TagCloseButton
                                                                                style={{
                                                                                    marginLeft: 5,
                                                                                    fontSize: 20,
                                                                                    cursor: "pointer",
                                                                                    color: 'red',
                                                                                }}
                                                                                onClick={() => {
                                                                                    setSousCat('');
                                                                                    setScatName('');
                                                                                    setName('');
                                                                                }}
                                                                            />
                                                                        </PopoverTrigger>
                                                                        <PopoverContent>
                                                                            <PopoverArrow />
                                                                            <PopoverHeader>Confirmation</PopoverHeader>
                                                                            <PopoverCloseButton />
                                                                            <PopoverBody>
                                                                                {t(
                                                                                    "êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement."
                                                                                )}
                                                                            </PopoverBody>
                                                                            <PopoverFooter display='flex' justifyContent='flex-end'>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        handleSCatDelete(val.id);
                                                                                        onClose();
                                                                                    }}
                                                                                    size={'sm'}
                                                                                    colorScheme='red'
                                                                                >
                                                                                    {t("Supprimer")}
                                                                                </Button>
                                                                            </PopoverFooter>
                                                                        </PopoverContent>
                                                                    </>
                                                                )}
                                                            </Popover>}
                                                        </Flex>

                                                    </Tag>
                                                ))}
                                    </Box>
                                </Flex> : null}

                        </AlertDialogBody>

                        <AlertDialogFooter>


                            <Button mr={2} ref={cancelRef} onClick={() => {
                                setScatName()
                                setName()
                                onCloseCat()
                                setSousCat('')
                                reset()
                            }}

                            >
                                {t("Annuler")}
                            </Button>
                            {isEditFormOpen ?
                                <Button
                                    isLoading={isLoading}
                                    isDisabled={isLoading}
                                    colorScheme='teal' onClick={() => {
                                        updateSousCategory(sousCat.id)
                                    }}
                                >
                                    {t("Modifier")}
                                </Button>
                                : null}
                            {isAddFormOpen ?
                                (!scatName?.trim() || !sCatDescription?.trim())
                                    ?
                                    <Button colorScheme='green' title="Entrer le nom de sous catégorie" isDisabled
                                    >
                                        {t("Ajouter")}
                                    </Button>
                                    :
                                    <Button
                                        isLoading={isLoading}
                                        isDisabled={isLoading}
                                        colorScheme='green'
                                        onClick={AjoutSubCategory}
                                    >
                                        {t("Ajouter")}
                                    </Button>
                                : null
                            }

                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer catégorie")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(catId)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {changeModal ?
                //Modal d'ajout cat
                <Modal size={"lg"} isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')
                }}>
                    <ModalOverlay />

                    <ModalContent>

                        <ModalHeader>{t("Ajout d'une catégorie")}</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w={"100%"} flexDirection={"column"}>

                                    <FormControl isRequired>
                                        <FormLabel>{t("Nom de catégorie")}</FormLabel>
                                        <Input maxLength={50} name="name" onChange={e => setName(e.target.value)} placeholder={t("Nom de catégorie")} />
                                    </FormControl>
                                    <FormControl mt={2} isRequired>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea height={"60px"} resize={"none"} type='text' maxLength={250} name="description" onChange={e => setDescription(e.target.value)} placeholder={t('Description de catégorie...')} />
                                    </FormControl>
                                </Flex>
                            </Flex>
                            {/* <Flex justify="end">
                  {name.length > 40
                    ? <Text fontSize='xs' color="red">{name.length}/50 caractères !</Text>
                    : <Text fontSize='xs'>{name.length}/50 {name.length > 1 ? "caractères" : "caractère"}</Text>
                  }
                </Flex> */}
                        </ModalBody>

                        <ModalFooter>
                            {(!name?.trim() || !description?.trim())
                                ?
                                <Button colorScheme='blue' title="Ajouter" isDisabled
                                >
                                    {t("Ajouter")}
                                </Button>
                                :
                                <Button colorScheme='blue'
                                    onClick={AjoutCategory}
                                    isLoading={isLoading}
                                    isDisabled={isLoading}
                                >
                                    {t("Ajouter")}
                                </Button>
                            }
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                :
                //Modal de modifaction
                <Modal size={"lg"} closeOnOverlayClick={false} isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')

                }}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{t("Modification de catégorie")}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w={"100%"} flexDirection={"column"}>

                                    <FormControl isRequired>
                                        <FormLabel>{t("Nom de catégorie")}</FormLabel>
                                        <Input maxLength={50} name="name" defaultValue={catData.name} onChange={e => setName(e.target.value)} placeholder={t("Nom de catégorie")} />
                                    </FormControl>
                                    <FormControl mt={2} isRequired>
                                        <FormLabel>Description</FormLabel>
                                        <Textarea height={"100px"} resize={"none"} type='text' defaultValue={catData.description} maxLength={250} name="description" onChange={e => setDescription(e.target.value)} placeholder={t('Description de catégorie...')} />
                                    </FormControl>
                                </Flex>
                            </Flex>
                        </ModalBody>

                        <ModalFooter>
                            <Button
                                isLoading={isLoading}
                                isDisabled={isLoading}
                                colorScheme='gray' onClick={() => {
                                    updateCategory(catId)

                                }}>
                                {t("Modifier")}
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            }

        </Box>

    )
}

export default GestCategory